var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import Plugin, { Events, Util } from '../../plugin';

var Poster = function (_Plugin) {
  _inherits(Poster, _Plugin);

  function Poster() {
    _classCallCheck(this, Poster);

    return _possibleConstructorReturn(this, (Poster.__proto__ || Object.getPrototypeOf(Poster)).apply(this, arguments));
  }

  _createClass(Poster, [{
    key: 'hide',
    value: function hide() {
      Util.addClass(this.root, 'hide');
    }
  }, {
    key: 'show',
    value: function show() {
      Util.removeClass(this.root, 'hide');
    }
  }, {
    key: 'beforeCreate',
    value: function beforeCreate(args) {
      if (typeof args.player.config.poster === 'string') {
        args.config.poster = args.player.config.poster;
      }
    }
  }, {
    key: 'afterCreate',
    value: function afterCreate() {
      var _this2 = this;

      this.on(Events.ENDED, function () {
        if (!_this2.isEndedShow) {
          Util.addClass(_this2.root, 'hide');
        }
      });

      if (this.config.hideCanplay) {
        this.once(Events.TIME_UPDATE, function () {
          _this2.onTimeUpdate();
        });
        this.on(Events.URL_CHANGE, function () {
          Util.removeClass(_this2.root, 'hide');
          Util.addClass(_this2.root, 'xg-showplay');
          _this2.once(Events.TIME_UPDATE, function () {
            _this2.onTimeUpdate();
          });
        });
      } else {
        this.on(Events.PLAY, function () {
          Util.addClass(_this2.root, 'hide');
        });
      }
    }
  }, {
    key: 'onTimeUpdate',
    value: function onTimeUpdate() {
      var _this3 = this;

      if (!this.player.currentTime) {
        this.once(Events.TIME_UPDATE, function () {
          _this3.onTimeUpdate();
        });
      } else {
        Util.removeClass(this.root, 'xg-showplay');
      }
    }
  }, {
    key: 'update',
    value: function update(poster) {
      if (!poster) {
        return;
      }
      this.config.poster = poster;
      this.root.style.backgroundImage = 'url(' + poster + ')';
    }
  }, {
    key: 'render',
    value: function render() {
      var _config = this.config,
          poster = _config.poster,
          hideCanplay = _config.hideCanplay;

      var style = poster ? 'background-image:url(' + poster + ');' : '';
      return '<xg-poster class="xgplayer-poster ' + (hideCanplay ? 'xg-showplay' : '') + '" style="' + style + '">\n    </xg-poster>';
    }
  }, {
    key: 'isEndedShow',
    set: function set(value) {
      this.config.isEndedShow = value;
    },
    get: function get() {
      return this.config.isEndedShow;
    }
  }], [{
    key: 'pluginName',
    get: function get() {
      return 'poster';
    }
  }, {
    key: 'defaultConfig',
    get: function get() {
      return {
        isEndedShow: true, // 是否在播放结束之后显示
        hideCanplay: false, // cnaplay 时间大于1的时候才隐藏
        poster: '' // 封面图地址
      };
    }
  }]);

  return Poster;
}(Plugin);

export default Poster;